<template>
    <div>
        <span class="text-info mr-2">
            <i
                class="fa fa-info-circle fa-lg icon-button"
                title="Visualizar Informações da Nota Fiscal"
                @click.stop="mostrarDetalhes()"
            ></i>
        </span>

        <!-- Modal de Detalhes usando o mesmo componente de inserir/editar -->
        <pagamento-nota-fiscal-form
            :mostrarModal="mostrarModal"
            :operacao="'VISUALIZAR'"
            :notaFiscal="notaFiscal"
            :pagamentoId="pagamentoNotaFiscal.pagamentoId"
            :pagamentosServicos="pagamentosServicos"
            :erros="[]"
            :somenteLeitura="perfilUsuario === 'GESTOR' || perfilUsuario === 'GERENTE'"
            :perfilUsuario="perfilUsuario"
            :pagamentoConcluido="pagamentoConcluido"
            :valorTotal="valorTotal"
            @fechar="fecharModal()"
            @salvar="salvarNotaFiscal"
        ></pagamento-nota-fiscal-form>
    </div>
</template>

<script>
import PagamentoNotaFiscalForm from './PagamentoNotaFiscalFormNovo.vue'

export default {
    props: {
        pagamentoNotaFiscal: {
            type: Object,
            default: () => ({})
        },

        pagamentosServicos: {
            type: Object,
            required: true,
            default: () => ({})
        },

        pagamentoConcluido: {
            type: Boolean,
            default: false
        },

        valorTotal: {
            type: Number,
            default: 0
        }
    },

    data() {
        return {
            mostrarModal: false,
            notaFiscal: null
        }
    },

    computed: {
        perfilUsuario() {
            if (this.$temAcesso('GESCON-UFI-PAG-01')) {
                return 'FINANCEIRO'
            } else if (this.$temAcesso('GESCON-GEST-PAG-00')) {
                return 'GESTOR'
            } else if (this.$temAcesso('GESCON-GER-PAG-00')) {
                return 'GERENTE'
            } else if (this.$temAcesso('GESCON-FORN-PAG-02')) {
                return 'FORNECEDOR'
            }
            return 'FORNECEDOR'
        }
    },

    methods: {
        mostrarDetalhes() {
            this.notaFiscal = { ...this.pagamentoNotaFiscal }
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
            this.notaFiscal = null
        },

        salvarNotaFiscal(dadosNotaFiscal) {
             const notaFiscalId = this.pagamentoNotaFiscal.pagamentoNotaFiscalId || 
                                this.pagamentoNotaFiscal.PagamentoNotaFiscalId || 
                                this.pagamentoNotaFiscal.id || 
                                this.pagamentoNotaFiscal.Id ||
                                this.pagamentoNotaFiscal.notaFiscalId
            
            
            if (!notaFiscalId || notaFiscalId === '00000000-0000-0000-0000-000000000000') {
              this.$toast.error(
                    'Erro: ID da nota fiscal não encontrado.',
                    'ERROR',
                    this.$toastConfig.error
                )
                return
            }
            
            // Verificar se o pagamentoId existe
            const pagamentoId = this.pagamentoNotaFiscal.pagamentoId || this.pagamentoNotaFiscal.PagamentoId
            if (!pagamentoId) {
                console.error('ID do pagamento não encontrado:', this.pagamentoNotaFiscal)
                this.$toast.error(
                    'Erro: ID do pagamento não encontrado.',
                    'ERROR',
                    this.$toastConfig.error
                )
                return
            }

            this.$store.dispatch('addRequest')
            
            // Usar o serviço de atualização para financeiro
            this.pagamentosServicos.atualizarNotaFiscal(
                pagamentoId, 
                notaFiscalId, 
                dadosNotaFiscal
            ).then(response => {
                if (response && response.success) {
                    this.$toast.success(
                        'Nota fiscal atualizada com sucesso!',
                        'SUCESSO',
                        this.$toastConfig.success
                    )
                    this.fecharModal()
                    // Emitir evento para atualizar a listagem
                    this.$emit('atualizar')
                } else {
                    this.$toast.error(
                        response?.message || 'Erro ao atualizar nota fiscal.',
                        'ERROR',
                        this.$toastConfig.error
                    )
                }
                this.$store.dispatch('removeRequest')
            }).catch(error => {
                console.error('Erro ao atualizar nota fiscal:', error)
                this.$toast.error(
                    'Erro ao atualizar nota fiscal.',
                    'ERROR',
                    this.$toastConfig.error
                )
                this.$store.dispatch('removeRequest')
            })
        }
    },

    components: {
        PagamentoNotaFiscalForm
    }
}
</script>
